import { FiMapPin } from "react-icons/fi";
import { GoPencil } from "react-icons/go";
import { Card, CardBody } from "reactstrap";
import IconButton from "../Buttons/IconButton";
import { BsTrash3 } from "react-icons/bs";

function AddressCard({ data, onEditClick, onDeleteClick }) {
  return(
    <Card>
      <CardBody>
        <div className="position-absolute top-0 m-2 end-0">
          <IconButton size="sm" className="me-2" outline onClick={onEditClick}>
            <GoPencil size={16} />
          </IconButton>
          <IconButton size="sm" color="danger" outline onClick={onDeleteClick}>
            <BsTrash3 size={16} />
          </IconButton>
        </div>

        <div className="d-flex align-items-center mb-3">
          <FiMapPin />
          <h5 className="ms-2 fw-bold mb-0">{ data.label }</h5>
        </div>

        <p className="mb-1">
          { data.street }
        </p>
        <p className="mb-1 text-muted small">
          { data.city }, { data.state } { data.postal_code }
        </p>
        <p className="mb-0 text-muted small">
          { data.country }
        </p>
      </CardBody>
    </Card>
  );
}

export default AddressCard;